<template>
    <slot />
</template>

<script setup>
    import { NearestMipmapLinearFilter, Vector2 } from 'three';
    import { computed, onMounted, ref } from 'vue';

    import { basePaneOptions, usePane, useRafBool, useThreeObject } from '@resn/gozer-vue';

    import { useFootball } from '../../common/Objects/useFootball';
    import { createPackSceneObjectMaterial } from '../../materials/PackSceneObjectMaterial';
    import { useSceneObject } from './useSceneObject';
    import { useModelExporter } from '~/composables/useModelExporter';

    const props = defineProps({
        visible: { type: Boolean, default: false },
        object: { type: Object, default: null, required: true },
        layer: { type: Number, default: 0 },
        overrideMaterial: { type: Object, default: null },
        tier: { type: String, default: 'normal' },
        s: { type: Number, default: 0.95 },
        x: { type: Number, default: -0.01 },
        y: { type: Number, default: 0.01 },
        z: { type: Number, default: 0 },
        rx: { type: Number, default: 0.6 },
        ry: { type: Number, default: 0 },
        rz: { type: Number, default: 0.72 },
    });

    const active = computed(() => props.visible);

    const object = props.object;
    const rx = ref(props.rx);
    const ry = ref(props.ry);
    const rz = ref(props.rz);
    const px = ref(props.x);
    const py = ref(props.y);
    const pz = ref(props.z);
    const s = ref(props.s);

    useFootball({ object });

    const objectProps = { rx, ry, rz, s, px, py, pz };

    useSceneObject({ object, props, objectProps, name: 'Football' });

    useRafBool(active, ({ delta }) => {
        // ball.rotation.x += (delta / 1000) * 0.3;
    });

    const modelExport = useModelExporter();

    if (!modelExport) {
        // usePane(
        //     [
        //         { name: 'px', value: px, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'py', value: py, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'pz', value: pz, options: { min: -4, max: 1, step: 0.01 } },
        //         { name: 's', value: s, options: basePaneOptions },
        //         { name: 'rx', value: rx },
        //         { name: 'ry', value: ry },
        //         { name: 'rz', value: rz },
        //     ],
        //     { title: 'Football', expanded: false }
        // );
    }
</script>
